import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import DDIAQuoteProposalInfoPageStore, {
  DDIAQuoteProposalInfoPageStoreContext,
  useDDIAQuoteProposalInfoPageStore,
} from 'store/pages/quote/quote-proposal-info/ddia/pageStore';
import DDIAQuoteProposalInfoForm from 'components/quote/quote-proposal-info/DDIA';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { isActionLoading, flowDelegate, canCompleteStep, onComplete, getInitialData } =
    useDDIAQuoteProposalInfoPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={QuoteRouteV2Id.QUOTE_PROPOSAL_INFO}
      isPageLoading={flowDelegate.isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
      pageFooter={{
        onComplete,
        completeButtonText: 'Save',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <DDIAQuoteProposalInfoForm />
    </QuoteFlowLayout>
  );
});

const DDIAQuoteProposalInfoPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () => new DDIAQuoteProposalInfoPageStore({ groupId, periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <DDIAQuoteProposalInfoPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </DDIAQuoteProposalInfoPageStoreContext.Provider>
  );
};

export default DDIAQuoteProposalInfoPage;
